import React from "react";
import { FaArrowLeftLong } from "react-icons/fa6";

import FormDatePicker from "../../components/common/FormDatePicker/FormDatePicker";
import FormInput from "../../components/common/FormInput/FormInput";
import Button from "../../components/common/Button/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import UploadImage from "../../components/common/UploadImage/UplaodImage";

const AboutUs = () => {
  return (
    <>

      <div className="d-flex align-items-center gap-3 mb-4">
        <div
          className="d-flex align-items-center gap-2"
          style={{ cursor: "pointer" }}
          onClick={() => window.history.back()}
        >
          <FaArrowLeftLong />
           <h3 className="mb-0 management-tile ml-2">Blog Management</h3>
        </div>
      </div>

        <Row className="g-3">
<div class="mt-4 mb-2 col-12"><h5 class="Website-title">AboutUs Banner</h5><hr /></div>
        <Col xl={6} lg={6} sm={12}>
          <label className="form-label">AboutUs Banner Title</label>
          <FormInput placeholder="Industry Tag" />
        </Col>

        <Col xl={6} lg={6} sm={12}>
          <label className="form-label">Change User</label>
          <FormInput placeholder="Enter User" />
        </Col>

        <Col xl={6} lg={6} sm={12}>
          <label className="form-label">Select Date</label>
          <FormDatePicker />
        </Col>

        <Col xl={6} lg={6} sm={12}>
          <label className="form-label">Industry Title</label>
          <FormInput placeholder="Industry Title" />
        </Col>

        <Col xl={6} lg={6} sm={12}>
          <label className="form-label">Industry Description</label>
          <FormInput
            placeholder="Enter Industry description"
            type="textarea"
          />
        </Col>

        <Col xl={12} lg={12} sm={12}>
          <label className="form-label">Upload images / banner</label>
          <UploadImage />
        </Col>

        <Col xs={12} className="mt-3">
          <label className="form-label">Blog Details Title</label>
          <FormInput placeholder="Enter Blog Details" />
        </Col>

        <Col xs={12}>
          <label className="form-label">Blog Details Description</label>
          <FormInput
            type="textarea"
            placeholder="Enter Details Description"
          />
        </Col>

        <Col xs={12}>
          <Button>Add Blog</Button>
        </Col>
      </Row>
    </>
  );
};

export default AboutUs;
